import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../Icon';

import './styles.less';

const Follow = (props) => {
    const renderAccount = (acc, key) => {
        return (
            <li className="p-follow__item" key={key}>
                <a className="p-follow__link" title={`Follow on ${acc.service}`} href={acc.url ? acc.url : '#'}>
                    <span className={`p-follow__logo p-follow__logo--${acc.service}`}>
                        <Icon icon={acc.service} className="p-follow__icon" />
                    </span>
                    {props.showHandles && acc.account ? <span className="p-follow__account">{acc.account}</span> : null}
                </a>
            </li>
        );
    };

    return (
        <ul
            className={classNames({
                'p-follow': true,
                [`p-follow--${props.size}`]: true,
                'p-follow--show-handles': props.showHandles
            })}
            data-cid={props.contentId}
        >
            {props.accounts.map((acc, i) => {
                return acc.hideAccount ? null : renderAccount(acc, i);
            })}
        </ul>
    );
};

Follow.propTypes = {
    contentId: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg']),
    showHandles: PropTypes.bool,
    accounts: PropTypes.arrayOf(
        PropTypes.shape({
            service: PropTypes.oneOf([
                'facebook',
                'twitter',
                'instagram',
                'snapchat',
                'youtube',
                'google-plus',
                'pinterest',
                'tumblr',
                'spotify',
                'reddit',
                'email'
            ]).isRequired,
            hideAccount: PropTypes.bool.isRequired,
            account: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired
        })
    ).isRequired
};

Follow.defaultProps = {
    contentId: undefined,
    showHandles: false,
    size: 'sm'
};

export default Follow;
